<template>
  <div class="filter" :class="actionInputStyles">
    <div class="filter-inputs">
      <select
        v-model="action_name"
        class="action__question"
        :class="{ 'full-width': !showActionInput }"
        @change="resetAction()"
      >
        <option
          v-for="attribute in actionTypes"
          :key="attribute.key"
          :value="attribute.key"
        >
          {{ attribute.label }}
        </option>
      </select>
      <div v-if="showActionInput" class="filter__answer--wrap">
        <automation-action-ai-generated-email-input
          v-if="inputType === 'ai_generated_email'"
          v-model="action_params"
          class="w-full"
        />
        <div v-else-if="inputType" class="w-full">
          <div
            v-if="inputType === 'search_select'"
            :class="value.action_name === 'add_board' ? 'board_pipeline_select_wrap multiselect-wrap--small items-center' : 'multiselect-wrap--small'"
          >
            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
              :width="180"
            />

            <div
              v-if="this.value.action_name === 'add_board'"
              class="multiselect-wrap--small"
            >
              <multiselect
                v-model="statusValues"
                track-by="id"
                label="name"
                placeholder="Select pipeline"
                selected-label
                deselect-label=""
                select-label=""
                :max-height="160"
                :options="dropdownStatusValues"
                :allow-empty="false"
                :option-height="104"
                :width="180"
                class=""
              />
            </div>
          </div>
          <div
            v-else-if="inputType === 'multi_select'"
            class="multiselect-wrap--small multi-select-scope condition-multiselect"
          >
            <multiselect
              v-model="action_params"
              track-by="id"
              label="name"
              :placeholder="$t('FORMS.MULTISELECT.SELECT')"
              :multiple="true"
              selected-label
              :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
              deselect-label=""
              :max-height="160"
              :options="dropdownValues"
              :allow-empty="false"
              :option-height="104"
              :limit="2"
              :limit-text="limitText"
            />
          </div>
          <input
            v-else-if="inputType === 'email'"
            v-model="action_params"
            type="email"
            class="answer--text-input"
            placeholder="Enter email"
          />
          <input
            v-else-if="inputType === 'url'"
            v-model="action_params"
            type="url"
            class="answer--text-input"
            placeholder="Enter url"
          />
          <automation-action-file-input
            v-if="inputType === 'attachment'"
            v-model="action_params"
            :initial-file-name="initialFileName"
          />
        </div>
      </div>
      <woot-button
        v-if="!isMacro"
        icon="dismiss"
        variant="clear"
        color-scheme="secondary"
        @click="removeAction"
      />
    </div>
    <automation-action-team-message-input
      v-if="inputType === 'team_message'"
      v-model="action_params"
      :teams="dropdownValues"
    />
    <automation-action-api-webhook-input
      v-if="inputType === 'api_webhook'"
      v-model="action_params"
    />
    <automation-action-kivo-webhook-input
      v-if="inputType === 'kivo_webhook'"
      v-model="action_params"
      :validation="v"
    />
    <automation-action-reminder-input
      v-if="inputType === 'reminder'"
      v-model="action_params"
    />

    <div v-if="isWhatsappAction">
      <div v-if="isWhatsappAction && getWhatsappTemplateHeader">
        <p class="font-bold mt-4">HEADER</p>
        <img
          v-if="mediaType === 'IMAGE'"
          :src="mediaUrl"
          alt="Header Image"
          class="header-media"
          width="500"
        />

        <!-- Render video for video format -->
        <video
          v-if="mediaType === 'VIDEO'"
          ref="videoPlayer"
          :src="mediaUrl"
          controls
          width="500"
        ></video>

        <iframe
          v-if="mediaType === 'DOCUMENT'"
          :src="mediaUrl"
          class="header-media"
          width="500"
          height="700"
          frameborder="0"
        ></iframe>
            <!-- <input
              type="file"
              class="variable-input"
              :styles="{ marginBottom: 0 }"
              @change="handleFileChange"
            /> -->
      </div>

      <div v-if="isWhatsappAction && getWhatsappTemplateData">
        <p class="font-bold mt-4">BODY</p>
        <woot-message-editor
          v-model="getWhatsappTemplateData"
          rows="5"
          :enable-variables="true"
          :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
          class="action-message"
        />
      </div>
    </div>
    <div v-if="emailTemplateEditorVisible" class="email-template-macro-editors">
      <p class="font-bold mt-4 text-xs text-slate-500 uppercase">
        {{ $t('AUTOMATION.ACTION.EMAIL_TEMPLATE_SUBJECT_LABEL') }}
      </p>
      <woot-message-editor
        v-model="getEmailTemplateSubject"
        rows="2"
        :enable-variables="true"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        class="action-message"
      />
      <p class="font-bold mt-2 text-xs text-slate-500 uppercase">
        {{ $t('AUTOMATION.ACTION.EMAIL_TEMPLATE_BODY_LABEL') }}
      </p>
      <woot-message-editor
        v-model="getEmailTemplateBody"
        rows="5"
        :enable-variables="true"
        :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
        class="action-message"
      />
      <div
        v-if="emailTemplateAttachmentList.length"
        class="email-template-macro-attachments"
      >
        <p class="font-bold mt-3 text-xs text-slate-500 uppercase">
          {{ $t('AUTOMATION.ACTION.EMAIL_TEMPLATE_ATTACHMENTS_LABEL') }}
        </p>
        <ul class="email-template-macro-attachments__list">
          <li
            v-for="att in emailTemplateAttachmentList"
            :key="att.id || att.filename"
            class="email-template-macro-attachments__item"
          >
            <fluent-icon icon="document" size="14" class="mr-1 text-slate-500" />
            <span>{{ att.filename }}</span>
          </li>
        </ul>
      </div>
    </div>
    <woot-message-editor
      v-if="inputType === 'textarea'"
      v-model="castMessageVmodel"
      rows="4"
      :enable-variables="true"
      :placeholder="$t('AUTOMATION.ACTION.TEAM_MESSAGE_INPUT_PLACEHOLDER')"
      class="action-message"
    />
    <p
      v-if="v.action_params.$dirty && v.action_params.$error"
      class="filter-error"
    >
      {{ $t('FILTER.EMPTY_VALUE_ERROR') }}
    </p>
  </div>
</template>

<script>
import AutomationActionTeamMessageInput from './AutomationActionTeamMessageInput.vue';
import AutomationActionFileInput from './AutomationFileInput.vue';
import AutomationActionApiWebhookInput from './AutomationActionApiWebhookInput.vue';
import AutomationActionKivoWebhookInput from './AutomationActionKivoWebhookInput.vue';
import AutomationActionReminderInput from './AutomationActionReminderInput.vue';
import AutomationActionAiGeneratedEmailInput from './AutomationActionAiGeneratedEmailInput.vue';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import VariableList from './conversation/VariableList.vue';
import {
  suggestionsPlugin,
  triggerCharacters,
} from '@chatwoot/prosemirror-schema/src/mentions/plugin';

export default {
  components: {
    AutomationActionTeamMessageInput,
    AutomationActionFileInput,
    AutomationActionApiWebhookInput,
    AutomationActionKivoWebhookInput,
    AutomationActionReminderInput,
    AutomationActionAiGeneratedEmailInput,
    WootMessageEditor,
    VariableList
  },
  data(){
    return{
    mediaUrl: '',
    shouldShowVariables: false,
    variableSearchTerm: '',
    enableSuggestions: '',
    dropdownStatusValues: [],
    };
  },
  props: {
    value: {
      type: Object,
      default: () => null,
    },
    actionTypes: {
      type: Array,
      default: () => [],
    },
    dropdownValues: {
      type: Array,
      default: () => [],
    },
    v: {
      type: Object,
      default: () => null,
    },
    showActionInput: {
      type: Boolean,
      default: true,
    },
    initialFileName: {
      type: String,
      default: '',
    },
    isMacro: {
      type: Boolean,
      default: false,
    },
    statusValue: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    action_name: {
      get() {
        if (!this.value) return null;
        return this.value.action_name;
      },
      set(value) {
        const payload = this.value || {};
        this.$emit('input', { ...payload, action_name: value });
      },
    },
    action_params: {
      get() {
        if (!this.value) return null;
        return this.value.action_params;
      },
      set(value) {
        const payload = this.value || {};
        if(this.value?.action_name == "add_board" ){
          this.dropdownStatusValues = value?.statuses_attributes;
        }
        this.$emit('input', { ...payload, action_params: value, status: {} });
      },
    },
    statusValues: {
      get() {
        if (!this.value) return null;
        return this.value.status;
      },
      set(value) {
        const payload = this.value || {};
        console.log("vaueeee", payload);
        this.$emit('input', { ...payload, status: value });
      },
    },
    inputType() {
      return this.actionTypes.find(action => action.key === this.action_name)
        .inputType;
    }, 
    isWhatsappAction() {
      return this.action_name === 'whatsapp_template';
    },
    isEmailTemplateAction() {
      return this.action_name === 'email_template';
    },
    emailTemplateEditorVisible() {
      const p = this.action_params;
      return (
        this.isEmailTemplateAction &&
        p &&
        typeof p === 'object' &&
        !Array.isArray(p) &&
        p.id
      );
    },
    emailTemplateAttachmentList() {
      if (!this.emailTemplateEditorVisible) return [];
      const raw = this.action_params?.attachments;
      return Array.isArray(raw) && raw.length ? raw : [];
    },
    getEmailTemplateSubject: {
      get() {
        if (!this.emailTemplateEditorVisible) return '';
        return this.action_params.subject ?? '';
      },
      set(newValue) {
        const payload = this.value || {};
        const base =
          this.action_params &&
          typeof this.action_params === 'object' &&
          !Array.isArray(this.action_params)
            ? { ...this.action_params }
            : {};
        this.$emit('input', {
          ...payload,
          action_params: { ...base, subject: newValue },
          status: {},
        });
      },
    },
    getEmailTemplateBody: {
      get() {
        if (!this.emailTemplateEditorVisible) return '';
        return this.action_params.body ?? '';
      },
      set(newValue) {
        const payload = this.value || {};
        const base =
          this.action_params &&
          typeof this.action_params === 'object' &&
          !Array.isArray(this.action_params)
            ? { ...this.action_params }
            : {};
        this.$emit('input', {
          ...payload,
          action_params: { ...base, body: newValue },
          status: {},
        });
      },
    },

    selectedWhatsappTemplate() {
      if (!this.isWhatsappAction || !this.action_params) return null;
      if (Array.isArray(this.action_params)) {
        return this.action_params[0] || null;
      }
      return typeof this.action_params === 'object' ? this.action_params : null;
    },
    getWhatsappTemplateHeader: {
      get() {
        const template = this.selectedWhatsappTemplate;
        if (!template?.components) {
          this.mediaUrl = null;
          this.mediaType = null;
          return null;
        }

        const headerComponent = template.components.find(component => {
          if (!component) return false;
          return (
            component.type === 'HEADER' ||
            component.header_handle ||
            component.format === 'IMAGE' ||
            component.format === 'VIDEO' ||
            component.format === 'DOCUMENT'
          );
        });

        if (headerComponent) {
          this.mediaUrl =
            headerComponent.example?.header_handle ||
            headerComponent.header_handle ||
            null;
          this.mediaType = headerComponent.format;
          return this.mediaUrl;
        }

        this.mediaUrl = null;
        this.mediaType = null;
        return null;
      },
    },
    getWhatsappTemplateData: {
      get() {
        const template = this.selectedWhatsappTemplate;
        if (!template?.components) return null;

        const bodyText = template.components
          .map(component => component?.text)
          .filter(Boolean)
          .join('\n');
        return bodyText || template.components[0]?.text || null;
      },
      set(newValue) {
        const current = this.value || {};
        const template = this.selectedWhatsappTemplate || {
          id: this.action_params?.id || this.action_params?.[0],
        };
        const components =
          Array.isArray(template.components) && template.components.length
            ? template.components.map((component, index) =>
                index === 0 ? { ...component, text: newValue } : { ...component }
              )
            : [{ text: newValue, header_handle: this.mediaUrl, format: this.mediaType }];

        this.$emit('input', {
          ...current,
          action_name: this.action_name || 'whatsapp_template',
          action_params: { ...template, components },
        });
      },
    },
    totalInputFields() {
      if (this.isWhatsappAction && this.action_params.components && this.action_params.components[0].example.body_text) {
        return this.action_params.components[0].example.body_text[0];
      }
      return [];
    },
    actionInputStyles() {
      return {
        'has-error': this.v.action_params.$dirty && this.v.action_params.$error,
        'is-a-macro': this.isMacro,
      };
    },
    castMessageVmodel: {
      get() {
        if (Array.isArray(this.action_params)) {
          return this.action_params[0];
        }
        return this.action_params;
      },
      set(value) {
        this.action_params = value;
      },
    },
  },
  methods: {
    async handleFileChange(event) {
      this.file = event.target.files[0];
      if (file) {
        const url = URL.createObjectURL(file);
        this.mediaUrl = encodeURIComponent(url);
        console.log(this.mediaUrl)
        this.$nextTick(() => {
        if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.load();
          }
        }); 
      }
    },
    removeAction() {
      this.$emit('removeAction');
    },
    resetAction() {
      this.$emit('resetAction');
    },
    limitText(count) {
      return `+${count}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.filter {
  @apply bg-slate-50 dark:bg-slate-800 p-2 border border-solid border-slate-75 dark:border-slate-600 rounded-md mb-2;

  &.is-a-macro {
    @apply mb-0 bg-white dark:bg-slate-700 p-0 border-0 rounded-none;
  }
}

.no-margin-bottom {
  @apply mb-0;
}

.filter.has-error {
  @apply bg-red-50 dark:bg-red-800/50 border-red-100 dark:border-red-700/50;
}

.filter-inputs {
  @apply flex items-center;
}

.filter-error {
  @apply text-red-500 dark:text-red-200 block my-1 mx-0;
}

.action__question,
.filter__operator {
  @apply mb-0 mr-1;
}

.action__question {
  @apply max-w-[50%];
}

.action__question.full-width {
  @apply max-w-full;
}

.filter__answer--wrap {
  @apply max-w-[50%] flex-grow mr-1 flex w-full items-center justify-start;

  input {
    @apply mb-0;
  }
}
.filter__answer {
  &.answer--text-input {
    @apply mb-0;
  }
}

.filter__join-operator-wrap {
  @apply relative z-20 m-0;
}

.filter__join-operator {
  @apply flex items-center justify-center relative my-2.5 mx-0;

  .operator__line {
    @apply absolute w-full border-b border-solid border-slate-75 dark:border-slate-600;
  }

  .operator__select {
    margin-bottom: var(--space-zero) !important;
    @apply relative w-auto;
  }
}

.multiselect {
  @apply mb-0;
}
.action-message {
  @apply mt-2 mx-0 mb-0;
}
// Prosemirror does not have a native way of hiding the menu bar, hence
:deep(.ProseMirror-menubar) {

  @apply hidden;
}
.automated-mention-box{
  display: flex;
  justify-content: center;
  align-items: baseline;
}
.automated-mention-box label {
  margin: 0px 20px 0px 0px;
}
.whatsapp_action_input_box{
  width: 100% !important;
  height: 100%!important;
}
/* Scoped styles */
::v-deep(.multi-select-scope .multiselect),
::v-deep(.multi-select-scope .multiselect__tags) {
  //height: fit-content;
}

::v-deep(.multi-select-scope .multiselect__tags-wrap) {
  width: 100%;
  overflow-x: hidden;
}

::v-deep(.multi-select-scope .multiselect__tags input) {
  height: 100%;
}


::v-deep(.multiselect__content-wrapper) {
  position: static !important;
}
::v-deep .multiselect__input {
  background-color: transparent !important;
}
::v-deep .multiselect__placeholder {
  margin-left: -3px;
}
::v-deep .multiselect__option::after {
  content: none !important;
}

// ::v-deep .multiselect {
//   height: fit-content;
// }
::v-deep .multiselect .multiselect__content {
  max-width: none;
}
::v-deep .multiselect, .multiselect__tags{
 //height: fit-content;
}
::v-deep .multiselect__tags{
 // height: fit-content;
}
::v-deep .multiselect__tags-wrap{
  width: 100%;
  overflow-x: hidden;  
}
::v-deep .multiselect__tags input{
  height: 100%;
}
::v-deep .mx-input{
   margin: 0;
}
::v-deep .multiselect__tag-icon {
  background: transparent !important;
}
::v-deep .multiselect__tag-icon::after {
  content: '\00d7' !important; /* × */
  //color: #266d4d !important;
  font-size: 14px !important;
  //line-height: 1 !important;
}
</style>

<style lang="scss">
/* Condition multiselect styles - fix overflow for status conditions */
/* Unscoped to penetrate multiselect component internals */
.multi-select-scope.condition-multiselect {
  .multiselect {
    min-height: 40px;
  }

  .multiselect__tags {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    overflow: hidden;
    padding: 6px 40px 6px 8px;
  }

  .multiselect__tags-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    overflow: hidden;
    flex: 1;
  }

  .multiselect__tag {
    flex-shrink: 0;
    max-width: 120px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 !important;
    padding: 4px 26px 4px 10px;
    font-size: 13px;
    line-height: 1.2;
  }

  .multiselect__tag-icon {
    line-height: 1.4;
    width: 20px;
    text-align: center;
  }

  /* Badge styling for +N count */
  .multiselect__strong {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin: 0 4px;
    padding: 4px 10px;
    font-size: 13px;
    font-weight: 600;
    color: white;
    background-color: #1f93ff;
    border-radius: 12px;
    min-width: 32px;
    height: 26px;
    line-height: 1;
  }
}

.email-template-macro-editors {
  @apply mt-2 px-0;
}

.email-template-macro-attachments {
  @apply mt-2 text-sm text-slate-600 dark:text-slate-300;

  &__list {
    @apply mt-1 space-y-1 pl-0 list-none;
  }

  &__item {
    @apply flex items-center;
  }
}
</style>
